import { useTranslation } from "react-i18next";
import { CenteredCell } from "../../../components/styled";
import { useTaxonomy } from "library/utils/useTaxonomy";

interface StatusCellProps {
  offerStatus: number | null | undefined;
}

export const StatusCell = ({ offerStatus }: StatusCellProps) => {
  const { t } = useTranslation();
  const taxonomy = useTaxonomy();

  // If taxonomy is still loading, show loading state
  if (!taxonomy) {
    return (
      <CenteredCell>
        <span>-</span>
      </CenteredCell>
    );
  }

  // Get the taxonomy item by ID from OfferStatus taxonomy
  const statusTaxonomy = taxonomy.OfferStatus?.byId?.[offerStatus ?? 0];

  const statusLabel = statusTaxonomy?.code
    ? t(statusTaxonomy.code)
    : offerStatus != null
    ? offerStatus.toString()
    : "-";

  return (
    <CenteredCell>
      <span data-help-status={statusTaxonomy?.code}>{statusLabel}</span>
    </CenteredCell>
  );
};
